import React, { FC, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Col, Form, message, Radio, Row, Select } from 'antd';
import moment from 'moment';
import { Link, useNavigate } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { routerPath } from '../../router/routerPath';
import { authContext } from '../../store/authStore/AuthContext';
import {
  BlueLayout,
  CloseButton,
  CustomBlock,
  CustomButton,
  CustomCheckbox,
  CustomDatePicker,
  CustomFormLayout,
  CustomGoBackButton,
  CustomMaskInput,
  CustomSelect,
  FormBlock,
  FormInput,
  FormItem,
  GridItem,
  RadioInfoBlock,
  ValidatorFormItem,
} from '../../styles/styled';
import {
  addressRegExp,
  diplomRegExp,
  educationLevelRegExp,
  emailRegExp,
  lastNameRegExp,
  onlyLettersRegExp,
  patronymicRegExp,
  phoneNumberRegExp,
  userNameRegExp,
} from '../../utils/patterns';
import { sortPublishers, sortRegions } from '../../utils/sortObject';
import { RegionsType } from '../ExpertPage/types';
import { LanguagesType, PublishersType } from '../NewApplicationPage/types';
import AcademicDegreeForm from './components/AcademicDegreeForm';
import { AcademicDegreesType, ScienceBranchesType, SpecialtiesType } from './components/AcademicDegreeForm/types';
import AcademicTitle from './components/AcademicTitle';
import { ExpertScientificTitleType } from './components/AcademicTitle/types';
import EducationInfoComponent from './components/EducationInfoComponent';
import SubjectAreaForm from './components/SubjectAreaForm';
import { NewExpertContainer } from './styled';
import {
  ExpertChangesType,
  ExpertDegree,
  ExpertEducationalInstitution,
  ExpertEducationalInstitutions,
  ExpertInstitutionsValidatorsType,
  ExpertType,
  ExpertValidatorType,
} from './types';

const { Option } = Select;

export type EducationInfoType = {
  type: 'add' | 'remove' | 'update';
  id?: number;
  expertEducational?: ExpertEducationalInstitution;
};

type NewExpertPageProps = {
  isFormComponent?: boolean;
  profileExpertForm?: ExpertType;
  changesState?: ExpertChangesType;
  updateChanges?: (newState: ExpertChangesType) => void;
  id?: number;
  refresh?: () => Promise<void>;
  refreshExpertData?: () => Promise<void>;
};

export const NewExpertPage: FC<NewExpertPageProps> = ({
  isFormComponent,
  profileExpertForm,
  refresh,
  refreshExpertData,
  changesState,
  id,
  updateChanges,
}) => {
  const [regionsState, setRegions] = useState<RegionsType>([]);
  const [expertFormState, setExpertFormState] = useState<ExpertType | null>(null);
  const [publishersState, setPublishersState] = useState<PublishersType>([]);
  const [languagesState, setLanguages] = useState<LanguagesType>([]);
  const [postDataState, setPostData] = useState<boolean>(false);
  const [expertValidatorState, setExpertValidator] = useState<ExpertValidatorType | null>(null);
  const [expertInstitutionsValidatorState, setExpertInstitutionsValidator] = useState<ExpertInstitutionsValidatorsType>(
    [],
  );
  const [scienceBranchesState, setScienceBranches] = useState<ScienceBranchesType>([]);
  const [specialtiesState, setSpecialties] = useState<SpecialtiesType>([]);
  const [genScienceBranches, setGenScienceBranches] = useState<ScienceBranchesType>([]);
  const [academicDegreesState, setAcademicDegrees] = useState<ScienceBranchesType>([]);
  const { state } = useContext(authContext);
  const navigate = useNavigate();

  const firstUpdate = useRef(false);

  //
  // function isValidEmail(expert: ExpertType) {
  //   return !!expert.email && /\S+@\S+\.\S+/.test(expert.email);
  // }
  //
  // function isValidPhone(expert: ExpertType) {
  //   return !!expert.phone && /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/.test(expert.phone);
  // }
  //
  // function isValidFirstName(expert: ExpertType) {
  //   return !!expert.first_name && /^[А-ЯЁа-яё]+$/.test(expert.first_name);
  // }
  //
  // function isValidLastName(expert: ExpertType) {
  //   return !!expert.last_name && /^[А-ЯЁа-яё]+$/.test(expert.last_name);
  // }
  //
  // function isValidPatronymic(expert: ExpertType) {
  //   return !!expert.patronymic && /^[А-ЯЁа-яё]+$/.test(expert.patronymic);
  // }

  // const expertValidatorFunc = (expert: ExpertType) => {

  const expertValidatorFunc = useCallback(
    (expert: ExpertType) => {
      setExpertValidator({
        first_name:
          !!expert.first_name && expert.first_name.length > 0 && userNameRegExp.test(expertFormState?.first_name || ''),
        last_name:
          !!expert.last_name && expert.last_name.length > 0 && lastNameRegExp.test(expertFormState?.last_name || ''),
        patronymic:
          !!expert.patronymic &&
          expert.patronymic.length > 0 &&
          patronymicRegExp.test(expertFormState?.patronymic || ''),
        phone: !!expert.phone && expert.phone.length > 0 && phoneNumberRegExp.test(expertFormState?.phone || '7'),
        email: !!expert.email && expert.email.length > 0 && emailRegExp.test(expertFormState?.email || ''),
      });
    },
    [
      expertFormState?.first_name,
      expertFormState?.last_name,
      expertFormState?.patronymic,
      expertFormState?.phone,
      expertFormState?.email,
    ],
  );

  const addScientificTitle = () => {
    if (expertFormState?.expert_scientific_titles) {
      setExpertFormState({
        ...expertFormState,
        expert_scientific_titles: [...expertFormState.expert_scientific_titles, {}],
      });
    } else {
      setExpertFormState({
        ...expertFormState,
        expert_scientific_titles: [{}],
      });
    }
  };

  const addExpertDegree = () => {
    if (expertFormState?.expert_degrees) {
      setExpertFormState({
        ...expertFormState,
        expert_degrees: [
          ...expertFormState.expert_degrees,
          { academic_degree: { id: 0 }, branch_of_science: { id: 0 }, file: { id: 0 } },
        ],
      });
      if (updateChanges)
        updateChanges({
          ...changesState,
          expert_degrees: [
            ...expertFormState.expert_degrees.map((el) => (el.id ? { id: el.id } : el)),
            { academic_degree: { id: 0 }, branch_of_science: { id: 0 }, file: { id: 0 } },
          ],
        });
    } else {
      if (updateChanges)
        updateChanges({
          ...changesState,
          expert_degrees: [{ academic_degree: { id: 0 }, branch_of_science: { id: 0 }, file: { id: 0 } }],
        });

      setExpertFormState({
        ...expertFormState,
        expert_degrees: [{ academic_degree: { id: 0 }, branch_of_science: { id: 0 }, file: { id: 0 } }],
      });
    }
  };

  const expertInstitutionsValidator = (expert: ExpertType) => {
    if (expert?.expert_educational_institutions) {
      setExpertInstitutionsValidator(
        expert?.expert_educational_institutions?.map((el) => {
          return {
            name: !!el.name && el.name.length > 0,
            specialty: !!el.specialty && el.specialty.length > 0 && onlyLettersRegExp.test(el?.specialty || ''),
            diplom_number:
              !!el.diplom_number && el.diplom_number.length > 0 && diplomRegExp.test(el?.diplom_number || ''),
            level_of_education:
              !!el.level_of_education &&
              el.level_of_education.length > 0 &&
              educationLevelRegExp.test(el?.level_of_education || ''),
            qualification: !!el.qualification && el.qualification.length > 0,
          };
        }),
      );
    }
  };

  useEffect(() => {
    if (firstUpdate.current) expertValidatorFunc(expertFormState ? expertFormState : {});
    else if (isFormComponent) firstUpdate.current = true;
  }, [expertFormState, isFormComponent, profileExpertForm, expertValidatorFunc]);

  useEffect(() => {
    if (profileExpertForm) {
      setExpertFormState({
        ...profileExpertForm,
        birthday: profileExpertForm?.birthday
          ? moment(profileExpertForm?.birthday, 'YYYY-MM-DD').format('DD.MM.YYYY')
          : undefined,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileExpertForm]);

  const updateExpertEducation = ({ type, id, expertEducational }: EducationInfoType) => {
    let result: ExpertEducationalInstitutions = expertFormState?.expert_educational_institutions
      ? [...expertFormState.expert_educational_institutions]
      : [];

    if (type === 'add' && expertEducational) {
      result.push(expertEducational);
    } else if (type === 'remove' && typeof id === 'number') {
      result = result.filter((el, idx) => idx !== id);
    } else if (type === 'update' && typeof id === 'number' && expertEducational) {
      result[id] = expertEducational;
    }

    setExpertFormState({ ...expertFormState, expert_educational_institutions: result });
    if (updateChanges) updateChanges({ ...changesState, expert_educational_institutions: result });
  };

  const removeExpertDegree = (id: number) => {
    if (expertFormState?.expert_degrees) {
      const expertDegrees = expertFormState.expert_degrees;
      expertDegrees.splice(id, 1);

      setExpertFormState({ ...expertFormState, expert_degrees: expertDegrees });
      if (updateChanges) updateChanges({ ...changesState, expert_degrees: expertDegrees });
    }
  };

  useEffect(() => {
    if (
      postDataState &&
      !isFormComponent &&
      expertValidatorState &&
      !Object.values(expertValidatorState).includes(false) &&
      expertInstitutionsValidatorState &&
      !Object.values(expertInstitutionsValidatorState)
        .map((el) => Object.values(el))
        .flat()
        .includes(false)
    ) {
      (async () => {
        try {
          const response = await api.post(endpoints.postExpert(), {
            ...expertFormState,
            birthday: expertFormState?.birthday
              ? moment(expertFormState?.birthday, 'DD.MM.YYYY').format('YYYY-MM-DD')
              : undefined,
            status: { id: 2 },
          });
          setPostData(false);

          if (response) {
            message.success('Эксперт успешно создан');
            navigate(-1);
          }
        } catch (error) {
          setPostData(false);
        }
      })();
    } else if (
      !id &&
      postDataState &&
      expertValidatorState &&
      !Object.values(expertValidatorState).includes(false) &&
      expertInstitutionsValidatorState &&
      !Object.values(expertInstitutionsValidatorState)
        .map((el) => Object.values(el))
        .flat()
        .includes(false) &&
      isFormComponent
    ) {
      setPostData(false);

      (async () => {
        try {
          const response = await api.put(endpoints.selfUpdateExpert(), {
            ...changesState,
            birthday: changesState?.birthday
              ? moment(changesState?.birthday, 'DD.MM.YYYY').format('YYYY-MM-DD')
              : undefined,
          });

          if (response) {
            message.success('Данные успешно обновлены');
            refresh ? refresh() : refreshExpertData && refreshExpertData();
            setPostData(false);
          }
        } catch (err) {}
      })();
    } else if (
      id &&
      postDataState &&
      expertValidatorState &&
      !Object.values(expertValidatorState).includes(false) &&
      expertInstitutionsValidatorState &&
      !Object.values(expertInstitutionsValidatorState)
        .map((el) => Object.values(el))
        .flat()
        .includes(false) &&
      isFormComponent
    ) {
      (async () => {
        try {
          const response = await api.put(endpoints.putExpert(id), {
            ...changesState,
            birthday: changesState?.birthday
              ? moment(changesState?.birthday, 'DD.MM.YYYY').format('YYYY-MM-DD')
              : undefined,
          });

          if (response) {
            if (changesState && Object.keys(changesState).includes('email') && expertFormState?.user?.id) {
              const userResponse = await api.put(endpoints.putUser(expertFormState.user.id), {
                email: changesState?.email,
              });

              if (userResponse) {
                message.success('Данные успешно обновлены');
              }
            }

            refresh ? refresh() : refreshExpertData && refreshExpertData();
            setPostData(false);
          }
        } catch (err) {}
      })();
    } else if (postDataState) setPostData(!postDataState);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postDataState]);

  const disabledDate = (current) => {
    return current && current < moment('1923-01-01');
  };

  useEffect(() => {
    (async () => {
      try {
        const regionsResponse = await api.get<RegionsType>(endpoints.getRegions());
        const languagesResponse = await api.get<LanguagesType>(endpoints.getLanguages());
        const publishersResponse = await api.get<PublishersType>(endpoints.getPublishers(0, 1000));
        const scienceBranchesResponse = await api.get<ScienceBranchesType>(endpoints.getScientificTitles());
        const specialtiesResponse = await api.get<SpecialtiesType>(endpoints.getSpecialties());
        const branchScienceResponse = await api.get<ScienceBranchesType>(endpoints.getScienceBranches());
        const academicDegreesResponse = await api.get<AcademicDegreesType>(endpoints.getAcademicDegrees());

        setAcademicDegrees(academicDegreesResponse.data);
        setGenScienceBranches(branchScienceResponse.data);
        setSpecialties(specialtiesResponse.data.sort(sortRegions));
        setScienceBranches(scienceBranchesResponse.data);
        setPublishersState(() => publishersResponse.data.sort(sortPublishers));
        setLanguages(languagesResponse.data);
        setRegions(regionsResponse.data.sort(sortRegions));
      } catch (e) {}
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <NewExpertContainer>
      {!isFormComponent && (
        <BlueLayout>
          <Link to={routerPath.expert}>
            <CustomGoBackButton>{'<'}</CustomGoBackButton>
          </Link>
          Добавить эксперта
        </BlueLayout>
      )}
      {state.isFederal && updateChanges && isFormComponent && (
        <GridItem padding="5px 50px">
          <CustomCheckbox
            checked={changesState?.status ? changesState?.status?.id === 4 : profileExpertForm?.status?.id === 4}
            onChange={(e) =>
              updateChanges({
                ...changesState,
                status: { id: e.target.checked ? 4 : 2 },
              })
            }
          >
            Архивный
          </CustomCheckbox>
        </GridItem>
      )}

      <Form
        onFinish={() => {
          expertValidatorFunc(expertFormState || {});
          setPostData(true);
          expertInstitutionsValidator(expertFormState || {});
          if (!isFormComponent) firstUpdate.current = true;
        }}
      >
        <FormBlock noBorderRadius white padding={!isFormComponent ? '25px' : '0 25px 25px 25px'}>
          {!isFormComponent && <CustomFormLayout size="25px">Регистрация эксперта в системе</CustomFormLayout>}
          <CustomFormLayout type="light" size="18px" padding="20px 0 20px 0">
            Контактная информация
          </CustomFormLayout>
          <Row gutter={[15, 15]}>
            <Col span={24}>
              <FormItem redstar>
                <p>Фамилия</p>

                <ValidatorFormItem validator={!lastNameRegExp.test(expertFormState?.last_name || '')}>
                  <FormInput
                    error={!!expertValidatorState && !expertValidatorState?.last_name}
                    value={expertFormState?.last_name}
                    onChange={(e) => {
                      setExpertFormState({
                        ...expertFormState,
                        last_name: e.target.value,
                      });
                      updateChanges &&
                        updateChanges({
                          ...changesState,
                          last_name: e.target.value,
                        });
                    }}
                  />
                </ValidatorFormItem>
              </FormItem>
            </Col>
            <Col span={10}>
              <ValidatorFormItem redstar validator={!userNameRegExp.test(expertFormState?.first_name || '')}>
                <p>Имя</p>
                <Form.Item initialValue={expertFormState?.first_name} rules={[{ required: true }]}>
                  <FormInput
                    error={!!expertValidatorState && !expertValidatorState?.first_name}
                    value={expertFormState?.first_name}
                    onChange={(e) => {
                      updateChanges &&
                        updateChanges({
                          ...changesState,
                          first_name: e.target.value,
                        });
                      setExpertFormState({
                        ...expertFormState,
                        first_name: e.target.value,
                      });
                    }}
                  />
                </Form.Item>
              </ValidatorFormItem>
            </Col>
            <Col span={10}>
              {' '}
              <ValidatorFormItem redstar validator={!patronymicRegExp.test(expertFormState?.patronymic || '')}>
                <p>Отчество</p>
                <FormInput
                  value={expertFormState?.patronymic}
                  error={!!expertValidatorState && !expertValidatorState?.patronymic}
                  onChange={(e) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        patronymic: e.target.value,
                      });
                    setExpertFormState({
                      ...expertFormState,
                      patronymic: e.target.value,
                    });
                  }}
                />
              </ValidatorFormItem>
            </Col>
            <Col span={4}>
              <FormItem>
                <p>Дата рождения</p>
                <CustomDatePicker
                  onChange={(date, dateString) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        birthday: dateString,
                      });

                    setExpertFormState({
                      ...expertFormState,
                      birthday: dateString,
                    });
                  }}
                  allowClear
                  disabledDate={disabledDate}
                  value={expertFormState?.birthday ? moment(expertFormState.birthday, 'DD.MM.YYYY') : undefined}
                  format={'DD.MM.YYYY'}
                  placeholder=""
                />
              </FormItem>
            </Col>
            <Col span={10}>
              <ValidatorFormItem redstar validator={!phoneNumberRegExp.test(expertFormState?.phone || '7')}>
                <p>Телефон</p>

                <CustomMaskInput
                  mask="+7 (999) 999 - 99 - 99"
                  value={expertFormState?.phone}
                  onChange={(e) => {
                    setExpertFormState({
                      ...expertFormState,
                      phone: e.target.value,
                    });
                    updateChanges && updateChanges({ ...changesState, phone: e.target.value });
                  }}
                />
                {!!expertValidatorState && !expertValidatorState?.phone && (
                  <p style={{ color: 'red' }}>Неправильная форма заполнения номера телефона</p>
                )}
              </ValidatorFormItem>
            </Col>
            <Col span={10}>
              <ValidatorFormItem redstar validator={!emailRegExp.test(expertFormState?.email || '')}>
                <p>Email</p>
                <FormInput
                  value={expertFormState?.email}
                  error={!!expertValidatorState && !expertValidatorState?.email}
                  onChange={(e) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        email: e.target.value,
                      });

                    setExpertFormState({
                      ...expertFormState,
                      email: e.target.value,
                    });
                  }}
                />
              </ValidatorFormItem>
            </Col>
            <Col span={4} />
            <Col span={24}>
              <FormItem>
                <p>Регион</p>
                <CustomSelect
                  value={
                    expertFormState?.region
                      ? regionsState.find((el) => el.id === expertFormState.region?.id)?.title
                      : 'Все'
                  }
                  onChange={(value, option) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        region: { id: parseInt(Object.values(option)[0]) },
                      });

                    setExpertFormState({
                      ...expertFormState,
                      region: { id: parseInt(Object.values(option)[0]) },
                    });
                  }}
                  showSearch
                >
                  {regionsState.map((el) => {
                    return (
                      <Option key={el.id} value={el.title}>
                        {el.title}
                      </Option>
                    );
                  })}
                </CustomSelect>
              </FormItem>
            </Col>
            <Col span={24}>
              <ValidatorFormItem
                overLength={expertFormState?.address ? expertFormState.address.length > 255 : false}
                validator={!addressRegExp.test(expertFormState?.address || '')}
              >
                <p>Адрес фактического проживания</p>
                <FormInput
                  value={expertFormState?.address}
                  onChange={(e) => {
                    updateChanges && updateChanges({ ...changesState, address: e.target.value });

                    setExpertFormState({
                      ...expertFormState,
                      address: e.target.value,
                    });
                  }}
                />
              </ValidatorFormItem>
            </Col>
          </Row>
          <CustomFormLayout type="light" size="18px" padding="5px 0 5px 0">
            Сведения об образовании
          </CustomFormLayout>
          {expertFormState?.expert_educational_institutions?.map((el, key) => {
            return (
              <EducationInfoComponent
                id={key}
                validator={expertInstitutionsValidatorState && expertInstitutionsValidatorState[key]}
                readyEducationalInfo={el}
                updateEducationalInfo={({ type, id, expertEducational }: EducationInfoType) =>
                  updateExpertEducation({
                    type: type,
                    id: id,
                    expertEducational: expertEducational,
                  })
                }
                key={key}
              />
            );
          })}
          <CustomButton
            onClick={() =>
              updateExpertEducation({
                type: 'add',
                expertEducational: {},
              })
            }
            lined
            width="300px"
            type="button"
          >
            добавить учебное заведение
          </CustomButton>
          <CustomFormLayout type="light" size="18px" padding="5px 0 5px 0">
            Учёная степень
          </CustomFormLayout>
          {expertFormState?.expert_degrees &&
            expertFormState?.expert_degrees?.map((el, key) => {
              return (
                <AcademicDegreeForm
                  academicDegrees={academicDegreesState}
                  genScienceBranches={genScienceBranches}
                  key={key}
                  id={key}
                  inputData={isFormComponent ? el : undefined}
                  updateForm={(expertDegree: ExpertDegree, id: number) => {
                    if (updateChanges)
                      updateChanges({
                        ...changesState,
                        expert_degrees: expertFormState?.expert_degrees?.map((e, idx) => {
                          return idx === id ? expertDegree : e;
                        }),
                      });

                    setExpertFormState({
                      ...expertFormState,
                      expert_degrees: expertFormState?.expert_degrees?.map((e, idx) => {
                        return idx === id ? expertDegree : e;
                      }),
                    });
                  }}
                  removeForm={(id) => removeExpertDegree(id)}
                />
              );
            })}
          <Form.Item htmlFor="button">
            <CustomButton type="button" onClick={() => addExpertDegree()} lined>
              добавить
            </CustomButton>
          </Form.Item>
          <CustomFormLayout type="light" size="18px" padding="5px 0 5px 0">
            Учёное звание
          </CustomFormLayout>
          {expertFormState?.expert_scientific_titles?.map((el, key) => {
            return (
              <AcademicTitle
                key={key}
                scienceBranches={scienceBranchesState}
                specialties={specialtiesState}
                formData={isFormComponent ? el : undefined}
                updateForm={(id: number, institutionForm: ExpertScientificTitleType) => {
                  if (updateChanges)
                    updateChanges({
                      ...changesState,
                      expert_scientific_titles: expertFormState?.expert_scientific_titles?.map((el, idx) =>
                        idx === id ? institutionForm : el,
                      ),
                    });

                  setExpertFormState({
                    ...expertFormState,
                    expert_scientific_titles: expertFormState?.expert_scientific_titles?.map((el, idx) =>
                      idx === id ? institutionForm : el,
                    ),
                  });
                }}
                removeForm={(id) => {
                  setExpertFormState({
                    ...expertFormState,
                    expert_scientific_titles: expertFormState?.expert_scientific_titles?.filter(
                      (el, idx) => idx !== id,
                    ),
                  });

                  if (updateChanges)
                    updateChanges({
                      ...changesState,
                      expert_scientific_titles: expertFormState?.expert_scientific_titles?.filter(
                        (el, idx) => idx !== id,
                      ),
                    });
                }}
                id={key}
              />
            );
          })}
          <Form.Item htmlFor="button">
            <CustomButton type="button" onClick={() => addScientificTitle()} lined>
              добавить
            </CustomButton>
          </Form.Item>
          <CustomFormLayout type="light" size="18px" padding="5px 0 5px 0">
            Место работы
          </CustomFormLayout>
          <Row gutter={[20, 20]}>
            <Col span={24}>
              <FormItem>
                <p>Наименование организации</p>
                <FormInput
                  value={expertFormState?.name_of_organization}
                  onChange={(e) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        name_of_organization: e.target.value,
                      });

                    setExpertFormState({ ...expertFormState, name_of_organization: e.target.value });
                  }}
                />
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem>
                <p>Занимаемая должность</p>
                <FormInput
                  value={expertFormState?.position}
                  onChange={(e) => {
                    updateChanges && updateChanges({ ...changesState, position: e.target.value });

                    setExpertFormState({ ...expertFormState, position: e.target.value });
                  }}
                />
              </FormItem>
            </Col>
          </Row>
          <CustomFormLayout type="light" size="18px" padding="5px 0 5px 0">
            Стаж педагогической деятельности
          </CustomFormLayout>
          <Row gutter={[20, 20]}>
            <Col span={4}>
              <FormItem>
                <div className="row">
                  <FormInput
                    value={expertFormState?.experience}
                    onChange={(e) => {
                      updateChanges &&
                        updateChanges({
                          ...changesState,
                          experience: parseInt(e.target.value),
                        });

                      setExpertFormState({
                        ...expertFormState,
                        experience: parseInt(e.target.value),
                      });
                    }}
                    type="number"
                  />
                  <p>лет</p>
                </div>
              </FormItem>
            </Col>
          </Row>
          <CustomFormLayout type="light" size="18px" padding="20px 0 20px 0">
            Педагогический опыт реализации основных образовательных программ
          </CustomFormLayout>
          <Row gutter={[20, 20]}>
            <Col span={4}>
              <FormItem>
                <div className="row">
                  <FormInput
                    type="number"
                    value={expertFormState?.experience_of_implementation}
                    onChange={(e) => {
                      updateChanges &&
                        updateChanges({
                          ...changesState,
                          experience_of_implementation: parseInt(e.target.value),
                        });

                      setExpertFormState({
                        ...expertFormState,
                        experience_of_implementation: parseInt(e.target.value),
                      });
                    }}
                  />
                  <p>лет</p>
                </div>
              </FormItem>
            </Col>
          </Row>
          <CustomFormLayout redStar type="light" size="18px" padding="40px 0 0 0">
            Предметная область
          </CustomFormLayout>

          {expertFormState?.expert_teaching_experiences?.map((el, key) => {
            return (
              expertFormState?.expert_teaching_experiences && (
                <SubjectAreaForm
                  changeForm={(toChangeSubjectArea, id) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        expert_teaching_experiences: expertFormState?.expert_teaching_experiences?.map((el, idx) => {
                          return idx === id ? toChangeSubjectArea : el;
                        }),
                      });

                    setExpertFormState({
                      ...expertFormState,
                      expert_teaching_experiences: expertFormState?.expert_teaching_experiences?.map((el, idx) => {
                        return idx === id ? toChangeSubjectArea : el;
                      }),
                    });
                  }}
                  currentSubjectArea={expertFormState.expert_teaching_experiences[key]}
                  id={key}
                  key={key}
                  removeForm={() => {
                    setExpertFormState({
                      ...expertFormState,
                      expert_teaching_experiences: expertFormState?.expert_teaching_experiences?.filter(
                        (e, idx) => idx !== key,
                      ),
                    });

                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        expert_teaching_experiences: changesState?.expert_teaching_experiences?.filter(
                          (e, idx) => idx !== key,
                        ),
                      });
                  }}
                />
              )
            );
          })}
          <br />

          <Form.Item htmlFor="button">
            <CustomButton
              type="button"
              onClick={() =>
                setExpertFormState({
                  ...expertFormState,
                  expert_teaching_experiences: expertFormState?.expert_teaching_experiences
                    ? [...expertFormState.expert_teaching_experiences, { subjects_general: [] }]
                    : [{ subjects_general: [] }],
                })
              }
              lined
              style={{ marginBottom: '40px' }}
            >
              добавить
            </CustomButton>
          </Form.Item>
          <Row>
            <Col span={24}>
              <FormItem>
                <p>Знание родных языков</p>
                <CustomSelect
                  // value={expertFormState?.native_languages?.map((el) => {
                  //   languagesState.find((e) => e.id === el.id)?.title;
                  // })}
                  // value={expertFormState?.native_languages?.find((el)=> el.id === languagesState?.id)?.title || ''}
                  mode="multiple"
                  optionLabelProp="label"
                  onChange={(value, option) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        native_languages: option.map((el: { key: string }) => {
                          return { id: parseInt(el.key) };
                        }),
                      });

                    setExpertFormState({
                      ...expertFormState,
                      native_languages: option.map((el: { key: string }) => {
                        return { id: parseInt(el.key) };
                      }),
                    });
                  }}
                >
                  {languagesState.map((language) => (
                    <Option key={language.id} value={language.title}>
                      {language.title}
                    </Option>
                  ))}
                </CustomSelect>
              </FormItem>
            </Col>
          </Row>
          <br />
          <Row gutter={[30, 30]} style={{ paddingTop: '20px' }}>
            <Col span={24}>
              <RadioInfoBlock redStar>
                <div className="text">
                  Знание требований нормативных правовых актов Российской Федерации в сфере образования, в том числе
                  федеральных государственных образовательных стандартов
                </div>
                <Radio.Group
                  value={expertFormState?.educational_law_awareness}
                  defaultValue={false}
                  onChange={(e) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        educational_law_awareness: e.target.value,
                      });
                    setExpertFormState({
                      ...expertFormState,
                      educational_law_awareness: e.target.value,
                    });
                  }}
                >
                  <Radio value={true}>Да</Radio>
                  <Radio value={false}>Нет</Radio>
                </Radio.Group>
              </RadioInfoBlock>
            </Col>
            <Col span={24}>
              <RadioInfoBlock redStar>
                <div className="text">
                  Опыт разработки или использования учебника(ов) или учебно-методических пособий в электронной форме,
                  программ для электронной вычислительной машины или др. электронных образовательных ресурсов
                </div>
                <Radio.Group
                  style={{ width: '100%' }}
                  value={expertFormState?.ecourses_experience}
                  defaultValue={false}
                  onChange={(e) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        ecourses_experience: e.target.value,
                        expert_ecourses: e.target.value === false ? [] : expertFormState?.expert_ecourses,
                      });
                    setExpertFormState({
                      ...expertFormState,
                      ecourses_experience: e.target.value,
                      expert_ecourses: e.target.value === false ? undefined : expertFormState?.expert_ecourses,
                    });
                  }}
                >
                  <Radio value={true}>Да</Radio>
                  <Radio value={false}>Нет</Radio>
                  {expertFormState?.ecourses_experience && (
                    <FormBlock margintop="20px">
                      {expertFormState &&
                        expertFormState?.expert_ecourses &&
                        expertFormState.expert_ecourses.map((el, index) => (
                          <GridItem wrap="nowrap" key={index} direction="row">
                            <FormInput
                              width="calc(100% - 45px)"
                              value={el.name}
                              onChange={(e) => {
                                updateChanges &&
                                  updateChanges({
                                    ...changesState,
                                    expert_ecourses: expertFormState?.expert_ecourses?.map((textbook_el, idx) => {
                                      return idx === index ? { name: e.target.value } : textbook_el;
                                    }),
                                  });
                                setExpertFormState({
                                  ...expertFormState,
                                  expert_ecourses: expertFormState?.expert_ecourses?.map((textbook_el, idx) => {
                                    return idx === index ? { name: e.target.value } : textbook_el;
                                  }),
                                });
                              }}
                            />
                            <CloseButton
                              onClick={() => {
                                setExpertFormState({
                                  ...expertFormState,
                                  expert_ecourses: expertFormState?.expert_ecourses?.filter((e, idx) => idx !== index),
                                });
                                updateChanges &&
                                  updateChanges({
                                    ...changesState,
                                    expert_ecourses: expertFormState?.expert_ecourses?.filter(
                                      (e, idx) => idx !== index,
                                    ),
                                  });
                              }}
                              positioned
                              pressed
                            >
                              +
                            </CloseButton>
                          </GridItem>
                        ))}

                      <Form.Item htmlFor="button">
                        <CustomButton
                          type="button"
                          width="300px"
                          onClick={() =>
                            setExpertFormState({
                              ...expertFormState,
                              expert_ecourses: expertFormState?.expert_ecourses
                                ? [...expertFormState?.expert_ecourses, { name: '' }]
                                : [{ name: '' }],
                            })
                          }
                        >
                          Добавить учебник
                        </CustomButton>
                      </Form.Item>
                    </FormBlock>
                  )}
                </Radio.Group>
              </RadioInfoBlock>
            </Col>
            <Col span={24}>
              <RadioInfoBlock style={{ width: '100%' }} redStar>
                <div className="text">Опыт осуществления картографической деятельности не менее 5 лет</div>

                <Radio.Group
                  value={expertFormState?.cartographic_experience}
                  defaultValue={false}
                  style={{ width: '100%' }}
                  // onChange={(e) =>
                  //   setExpertFormState({
                  //     ...expertFormState,
                  //     cartographic_experience: e.target.value,
                  //     cartographic_experience_experience: undefined,
                  //     expert_cartographic_experience_organizations:
                  //       e.target.value === false
                  //         ? undefined
                  //         : expertFormState?.expert_cartographic_experience_organizations,
                  //   })

                  // }
                  onChange={(e) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        cartographic_experience: e.target.value,
                        cartographic_experience_experience:
                          e.target.value === false ? undefined : expertFormState?.cartographic_experience_experience,
                        expert_cartographic_experience_organizations:
                          e.target.value === false ? [] : expertFormState?.expert_cartographic_experience_organizations,
                      });
                    setExpertFormState({
                      ...expertFormState,
                      cartographic_experience: e.target.value,
                      cartographic_experience_experience:
                        e.target.value === false ? undefined : expertFormState?.cartographic_experience_experience,
                      expert_cartographic_experience_organizations:
                        e.target.value === false
                          ? undefined
                          : expertFormState?.expert_cartographic_experience_organizations,
                    });
                  }}
                >
                  <Radio value={true}>Да</Radio>
                  <Radio value={false}>Нет</Radio>
                  {expertFormState?.cartographic_experience && (
                    <FormBlock margintop="20px">
                      <GridItem gap="10px" direction="row" wrap="nowrap">
                        <FormInput
                          // value={
                          //   expertFormState?.cartographic_experience_experience
                          //     ? expertFormState?.cartographic_experience_experience
                          //     : 5
                          // }
                          value={expertFormState?.cartographic_experience_experience}
                          // onChange={(e) =>
                          //   setExpertFormState({
                          //     ...expertFormState,
                          //     cartographic_experience_experience:
                          //       parseInt(e.target.value) > 5 ? parseInt(e.target.value) : 5,
                          //   })
                          // }
                          onChange={(e) => {
                            updateChanges &&
                              updateChanges({
                                ...changesState,
                                cartographic_experience_experience:
                                  parseInt(e.target.value) > 5 ? parseInt(e.target.value) : 5,
                              });
                            setExpertFormState({
                              ...expertFormState,
                              cartographic_experience_experience:
                                parseInt(e.target.value) > 5 ? parseInt(e.target.value) : 5,
                            });
                          }}
                          width="80px"
                          height="40px"
                          type="number"
                        />
                        <div>лет</div>
                      </GridItem>
                      {expertFormState &&
                        expertFormState.expert_cartographic_experience_organizations &&
                        expertFormState.expert_cartographic_experience_organizations.map((el, index) => (
                          <GridItem wrap="nowrap" key={index} direction="row">
                            <FormInput
                              width="calc(100% - 45px)"
                              value={el.name}
                              onChange={(e) => {
                                updateChanges &&
                                  updateChanges({
                                    ...changesState,
                                    expert_cartographic_experience_organizations:
                                      expertFormState?.expert_cartographic_experience_organizations?.map((el, idx) => {
                                        return idx === index ? { name: e.target.value } : el;
                                      }),
                                  });
                                setExpertFormState({
                                  ...expertFormState,
                                  expert_cartographic_experience_organizations:
                                    expertFormState?.expert_cartographic_experience_organizations?.map((el, idx) => {
                                      return idx === index ? { name: e.target.value } : el;
                                    }),
                                });
                              }}
                            />
                            <CloseButton
                              onClick={() => {
                                setExpertFormState({
                                  ...expertFormState,
                                  expert_cartographic_experience_organizations:
                                    expertFormState?.expert_cartographic_experience_organizations?.filter(
                                      (e, idx) => idx !== index,
                                    ),
                                });
                                updateChanges &&
                                  updateChanges({
                                    ...changesState,
                                    expert_cartographic_experience_organizations:
                                      expertFormState?.expert_cartographic_experience_organizations?.filter(
                                        (e, idx) => idx !== index,
                                      ),
                                  });
                              }}
                              positioned
                              pressed
                            >
                              +
                            </CloseButton>
                          </GridItem>
                        ))}

                      <Form.Item htmlFor="button">
                        <CustomButton
                          type="button"
                          onClick={() =>
                            setExpertFormState({
                              ...expertFormState,
                              expert_cartographic_experience_organizations:
                                expertFormState?.expert_cartographic_experience_organizations
                                  ? [...expertFormState?.expert_cartographic_experience_organizations, { name: '' }]
                                  : [{ name: '' }],
                            })
                          }
                          width="300px"
                        >
                          Добавить организацию
                        </CustomButton>
                      </Form.Item>
                    </FormBlock>
                  )}
                </Radio.Group>
              </RadioInfoBlock>
            </Col>
            <Col span={24}>
              <RadioInfoBlock redStar>
                <div className="text">
                  Наличие высшего образования (квалификации) в области коррекционной педагогики
                </div>
                <Radio.Group
                  value={expertFormState?.higher_education_correctional_pedagogy}
                  defaultValue={false}
                  style={{ width: '100%' }}
                  // onChange={(e) =>
                  //   setExpertFormState({
                  //     ...expertFormState,
                  //     higher_education_correctional_pedagogy: e.target.value,
                  //   })
                  // }
                  onChange={(e) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        higher_education_correctional_pedagogy: e.target.value,
                      });
                    setExpertFormState({
                      ...expertFormState,
                      higher_education_correctional_pedagogy: e.target.value,
                    });
                  }}
                >
                  <Radio value={true}>Да</Radio>
                  <Radio value={false}>Нет</Radio>
                </Radio.Group>
              </RadioInfoBlock>
            </Col>
            <Col span={24}>
              <RadioInfoBlock redStar>
                <div className="text">Опыт работы в области коррекционной педагогики не менее 5 лет</div>
                <Radio.Group
                  value={expertFormState?.special_needs_qualification}
                  defaultValue={false}
                  style={{ width: '100%' }}
                  // onChange={(e) =>
                  //   setExpertFormState({
                  //     ...expertFormState,
                  //     pedagogyExperience: e.target.value,
                  //     special_needs_qualification_experience: undefined,
                  //   })

                  // }
                  onChange={(e) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        special_needs_qualification: e.target.value,
                        special_needs_qualification_experience:
                          e.target.value === false
                            ? undefined
                            : expertFormState?.special_needs_qualification_experience,
                      });
                    setExpertFormState({
                      ...expertFormState,
                      special_needs_qualification: e.target.value,
                      special_needs_qualification_experience: undefined,
                    });
                  }}
                >
                  <Radio value={true}>Да</Radio>
                  <Radio value={false}>Нет</Radio>

                  {expertFormState?.special_needs_qualification && (
                    <FormBlock margintop="20px">
                      <GridItem gap="10px" wrap="nowrap" direction="row">
                        <FormInput
                          value={
                            expertFormState?.special_needs_qualification_experience
                              ? expertFormState?.special_needs_qualification_experience
                              : 5
                          }
                          onChange={(e) => {
                            updateChanges &&
                              updateChanges({
                                ...changesState,
                                special_needs_qualification_experience: Number(e.target.value),
                              });
                            setExpertFormState({
                              ...expertFormState,
                              special_needs_qualification_experience:
                                parseInt(e.target.value) > 5 ? parseInt(e.target.value) : 5,
                            });
                          }}
                          type="number"
                          width="80px"
                          height="40px"
                        />{' '}
                        <div className="text">лет</div>
                      </GridItem>
                    </FormBlock>
                  )}
                </Radio.Group>
              </RadioInfoBlock>
            </Col>
            <Col span={24}>
              <RadioInfoBlock redStar>
                <div className="text">Использование в своей деятельности учебников</div>
                <Radio.Group
                  defaultValue={false}
                  style={{ width: '100%' }}
                  value={expertFormState?.uses_school_textbook}
                  // onChange={(e) =>
                  //   setExpertFormState({
                  //     ...expertFormState,
                  //     uses_school_textbook: e.target.value,
                  //   })
                  // }
                  onChange={(e) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        uses_school_textbook: e.target.value,
                        expert_use_school_textbooks:
                          e.target.value === false ? [] : expertFormState?.expert_use_school_textbooks,
                      });
                    setExpertFormState({
                      ...expertFormState,
                      uses_school_textbook: e.target.value,
                      expert_ecourses:
                        e.target.value === false ? undefined : expertFormState?.expert_use_school_textbooks,
                    });
                  }}
                >
                  <Radio value={true}>Да</Radio>
                  <Radio value={false}>Нет</Radio>
                  {expertFormState?.uses_school_textbook && (
                    <FormBlock margintop="20px">
                      {expertFormState &&
                        expertFormState?.expert_use_school_textbooks &&
                        expertFormState.expert_use_school_textbooks.map((el, index) => (
                          <GridItem wrap="nowrap" key={index} direction="row">
                            <FormInput
                              width="calc(100% - 45px)"
                              value={el.name}
                              // onChange={(e) =>
                              //   setExpertFormState({
                              //     ...expertFormState,
                              //     expert_use_school_textbooks: expertFormState?.expert_use_school_textbooks?.map(
                              //       (textbook_el, idx) => {
                              //         return idx === index ? { name: e.target.value } : textbook_el;
                              //       },
                              //     ),
                              //   })
                              // }
                              onChange={(e) => {
                                updateChanges &&
                                  updateChanges({
                                    ...changesState,
                                    expert_use_school_textbooks: expertFormState?.expert_use_school_textbooks?.map(
                                      (textbook_el, idx) => {
                                        return idx === index ? { name: e.target.value } : textbook_el;
                                      },
                                    ),
                                  });
                                setExpertFormState({
                                  ...expertFormState,
                                  expert_use_school_textbooks: expertFormState?.expert_use_school_textbooks?.map(
                                    (textbook_el, idx) => {
                                      return idx === index ? { name: e.target.value } : textbook_el;
                                    },
                                  ),
                                });
                              }}
                            />
                            <CloseButton
                              onClick={() => {
                                setExpertFormState({
                                  ...expertFormState,
                                  expert_use_school_textbooks: expertFormState?.expert_use_school_textbooks?.filter(
                                    (e, idx) => idx !== index,
                                  ),
                                });
                                updateChanges &&
                                  updateChanges({
                                    ...changesState,
                                    expert_use_school_textbooks: expertFormState?.expert_use_school_textbooks?.filter(
                                      (e, idx) => idx !== index,
                                    ),
                                  });
                              }}
                              positioned
                              pressed
                            >
                              +
                            </CloseButton>
                          </GridItem>
                        ))}

                      <Form.Item htmlFor="button">
                        <CustomButton
                          type="button"
                          width="300px"
                          onClick={() =>
                            setExpertFormState({
                              ...expertFormState,
                              expert_use_school_textbooks: expertFormState?.expert_use_school_textbooks
                                ? [...expertFormState?.expert_use_school_textbooks, { name: '' }]
                                : [{ name: '' }],
                            })
                          }
                        >
                          Добавить учебник
                        </CustomButton>
                      </Form.Item>
                    </FormBlock>
                  )}
                </Radio.Group>
              </RadioInfoBlock>
            </Col>
            <Col span={24}>
              <RadioInfoBlock redStar>
                <div className="text">Является автором учебных изданий</div>

                <Radio.Group
                  value={expertFormState?.is_edu_editions_author}
                  defaultValue={false}
                  style={{ width: '100%' }}
                  onChange={(e) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        is_edu_editions_author: e.target.value,
                        expert_edu_editions: e.target.value === false ? [] : expertFormState?.expert_edu_editions,
                      });

                    setExpertFormState({
                      ...expertFormState,
                      is_edu_editions_author: e.target.value,
                      expert_edu_editions: e.target.value === false ? undefined : expertFormState?.expert_edu_editions,
                    });
                  }}
                >
                  <Radio value={true}>Да</Radio>
                  <Radio value={false}>Нет</Radio>

                  {expertFormState?.is_edu_editions_author && (
                    <FormBlock margintop="20px">
                      {expertFormState?.expert_edu_editions &&
                        expertFormState?.expert_edu_editions.length > 0 &&
                        expertFormState.expert_edu_editions.map((el, index) => (
                          <GridItem wrap="nowrap" key={index} direction="row">
                            <FormInput
                              width="calc(100% - 45px)"
                              value={el.name}
                              // onChange={(e) =>
                              //   setExpertFormState({
                              //     ...expertFormState,
                              //     expert_edu_editions: expertFormState?.expert_edu_editions?.map((textbook_el, idx) => {
                              //       return idx === index ? { name: e.target.value } : textbook_el;
                              //     }),
                              //   })
                              // }
                              onChange={(e) => {
                                updateChanges &&
                                  updateChanges({
                                    ...changesState,
                                    expert_edu_editions: expertFormState?.expert_edu_editions?.map(
                                      (textbook_el, idx) => {
                                        return idx === index ? { name: e.target.value } : textbook_el;
                                      },
                                    ),
                                  });
                                setExpertFormState({
                                  ...expertFormState,
                                  expert_edu_editions: expertFormState?.expert_edu_editions?.map((textbook_el, idx) => {
                                    return idx === index ? { name: e.target.value } : textbook_el;
                                  }),
                                });
                              }}
                            />
                            <CloseButton
                              onClick={() => {
                                setExpertFormState({
                                  ...expertFormState,
                                  expert_edu_editions: expertFormState?.expert_edu_editions?.filter(
                                    (e, idx) => idx !== index,
                                  ),
                                });
                                updateChanges &&
                                  updateChanges({
                                    ...changesState,
                                    expert_edu_editions: expertFormState?.expert_edu_editions?.filter(
                                      (e, idx) => idx !== index,
                                    ),
                                  });
                              }}
                              positioned
                              pressed
                            >
                              +
                            </CloseButton>
                          </GridItem>
                        ))}

                      <Form.Item htmlFor="button">
                        <CustomButton
                          type="button"
                          width="300px"
                          onClick={() =>
                            setExpertFormState({
                              ...expertFormState,
                              expert_edu_editions: expertFormState?.expert_edu_editions
                                ? [...expertFormState?.expert_edu_editions, { name: '' }]
                                : [{ name: '' }],
                            })
                          }
                        >
                          Добавить учебник
                        </CustomButton>
                      </Form.Item>
                    </FormBlock>
                  )}
                </Radio.Group>
              </RadioInfoBlock>
            </Col>
            <Col span={24}>
              <RadioInfoBlock redStar>
                <div className="text">Сотрудничает с издательствами</div>
                <Radio.Group
                  value={expertFormState?.publishers_cooperation}
                  defaultValue={false}
                  style={{ width: '100%' }}
                  // onChange={(e) =>
                  //   setExpertFormState({
                  //     ...expertFormState,
                  //     publishers_cooperation: e.target.value,
                  //     expert_publisher_cooperations: undefined,
                  //   })
                  // }
                  onChange={(e) => {
                    updateChanges &&
                      updateChanges({
                        ...changesState,
                        publishers_cooperation: e.target.value,
                        expert_publisher_cooperations:
                          e.target.value === false ? [] : expertFormState?.expert_publisher_cooperations,
                      });
                    setExpertFormState({
                      ...expertFormState,
                      publishers_cooperation: e.target.value,
                      expert_publisher_cooperations:
                        e.target.value === false ? undefined : expertFormState?.expert_publisher_cooperations,
                    });
                  }}
                >
                  <Radio value={true}>Да</Radio>
                  <Radio value={false}>Нет</Radio>

                  {expertFormState?.publishers_cooperation && (
                    <FormBlock margintop="20px">
                      {expertFormState?.expert_publisher_cooperations &&
                        expertFormState.expert_publisher_cooperations.map((el, index) => (
                          <GridItem wrap="nowrap" key={index} direction="row">
                            <CustomSelect
                              width="calc(100% - 45px)"
                              onChange={(value, option) => {
                                updateChanges &&
                                  updateChanges({
                                    ...changesState,
                                    expert_publisher_cooperations: expertFormState?.expert_publisher_cooperations?.map(
                                      (cooperation, idx) => {
                                        return idx === index
                                          ? { publisher: { id: parseInt(Object.values(option)[0]) } }
                                          : cooperation;
                                      },
                                    ),
                                  });
                                setExpertFormState({
                                  ...expertFormState,
                                  expert_publisher_cooperations: expertFormState?.expert_publisher_cooperations?.map(
                                    (cooperation, idx) => {
                                      return idx === index
                                        ? { publisher: { id: parseInt(Object.values(option)[0]) } }
                                        : cooperation;
                                    },
                                  ),
                                });
                              }}
                              value={
                                expertFormState?.expert_publisher_cooperations
                                  ? publishersState.find((publisher) => publisher?.id === el?.publisher?.id)?.title
                                  : 'Все'
                              }
                            >
                              {publishersState.map((publisher) => (
                                <Option key={publisher.id} value={publisher.title}>
                                  {publisher.title}
                                </Option>
                              ))}
                            </CustomSelect>
                            <CloseButton
                              onClick={() => {
                                setExpertFormState({
                                  ...expertFormState,
                                  expert_publisher_cooperations: expertFormState?.expert_publisher_cooperations?.filter(
                                    (e, idx) => idx !== index,
                                  ),
                                });
                                updateChanges &&
                                  updateChanges({
                                    ...changesState,
                                    expert_publisher_cooperations:
                                      expertFormState?.expert_publisher_cooperations?.filter((e, idx) => idx !== index),
                                  });
                              }}
                              positioned
                              pressed
                            >
                              +
                            </CloseButton>
                          </GridItem>
                        ))}

                      <Form.Item htmlFor="button">
                        <CustomButton
                          type="button"
                          onClick={() =>
                            setExpertFormState({
                              ...expertFormState,
                              expert_publisher_cooperations: expertFormState?.expert_publisher_cooperations
                                ? [...expertFormState?.expert_publisher_cooperations, { publisher: { id: 0 } }]
                                : [{ publisher: { id: 0 } }],
                            })
                          }
                          width="300px"
                        >
                          Добавить издательство
                        </CustomButton>
                      </Form.Item>
                    </FormBlock>
                  )}
                </Radio.Group>
              </RadioInfoBlock>
            </Col>
          </Row>
          <CustomBlock>
            <Form.Item htmlFor="submit">
              <CustomButton type="submit">сохранить</CustomButton>
            </Form.Item>
          </CustomBlock>
        </FormBlock>
      </Form>
    </NewExpertContainer>
  );
};
